export default "__VITE_ASSET__454b3199__"